const component = "site-consumption-monitoring-section-category-filter";

export const siteConsumptionMonitoringSectionCategoryFilter = {
  component,
  cancelButton: `${component}/cancel-button`,
  submitButton: `${component}/submit-button`,
};
